import { render } from "./private-birthday-toggle.vue?vue&type=template&id=63d95323&lang=pug"
import script from "./private-birthday-toggle.vue?vue&type=script&lang=js"
export * from "./private-birthday-toggle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__